import { FocusGroupReport } from '@/features/focus-group';

export function FocusGroupDetail() {
  return <FocusGroupReport />;
}
